module.exports = __webpack_public_path__ + "media/images/products/longlife/flow-img-1-d0768af4131167dc08bdefc96170100c.png";